{{#compare languages.length ">" 1}}
<div class="input-list">
<label for="locale-selector" class="{{#if label_class}} {{label_class}} {{else}}p1{{/if}} ">{{ t 'localeSelector.labelText'}}</label>
  <select id="locale-selector">
    {{#each languages}}
      <option value="{{code}}" {{#if selected}}selected="selected"{{/if}}>{{text}}</option>
    {{/each}}
  </select>
{{/compare}}
</div>